import { render, staticRenderFns } from "./barraProg.vue?vue&type=template&id=05e66883&scoped=true&"
import script from "./barraProg.vue?vue&type=script&lang=js&"
export * from "./barraProg.vue?vue&type=script&lang=js&"
import style0 from "./barraProg.vue?vue&type=style&index=0&id=05e66883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e66883",
  null
  
)

export default component.exports